<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="system/user"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
        @select="selectHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="用户类型">
            <el-select v-model="filter.userType" placeholder="请选择用户类型" clearable>
              <el-option label="内部用户" :value="1"/>
              <el-option label="外部用户" :value="2"/>
              <el-option label="高级用户" :value="3"/>
            </el-select>
          </el-form-item>
          <el-form-item label="用户名" label-width="64px">
            <el-input v-model.trim="filter.userName" placeholder="请输入用户名" clearable/>
          </el-form-item>
          <el-form-item label="用户姓名">
            <el-input v-model.trim="filter.employeeName" placeholder="请输入用户姓名" clearable/>
          </el-form-item>
          <el-form-item label="所属部门">
            <el-input v-model.trim="filter.departmentName" placeholder="请输入所属部门" clearable/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="otherBtn">
        <el-button v-if="limits.passwordAuth" type="primary" @click="resetPassword">重置密码</el-button>
      </template>
    </viewTable>
    <user-edit ref="userEdit" @save-success="loadData()"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import UserEdit from "./UserEdit.vue";
  export default {
    name: "UserList",
    components: { viewTable, UserEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(259),
          editAuth: this.$auth(261),
          delAuth: this.$auth(262),
          passwordAuth: this.$auth(260),
        },
        filter: {
          userType: "",
          userName: "",
          employeeName: "",
          departmentName: "",
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "userName",
            width: 120,
            align: "center",
          },
          {
          tooltip: true,
            key: "userTypeName",
            width: 110,
            align: "center",
          },
          {
          tooltip: true,
            key: "employeeName",
            width: 100,
            align: "center",
          },
          {
          tooltip: true,
            key: "employeeNo",
            width: 90,
            align: "center",
          },
          {
          tooltip: true,
            key: "mobile",
            width: 120,
            align: "center",
          },
          {
            key: "departmentName",
            width: 200,
            tooltip: true,
          },
          {
            key: "roleName",
            tooltip: true,
            minWidth: 300,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.userEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        let ids = [];
        ids.push(row.systemUserID);
        this.$http.post("basic", "system/user/deleteBatch", ids).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      resetPassword() {
        let selection = this.selection;
        if (selection.length > 1 || !selection.length) {
          this.$confirm("请选择一个需要重置密码的用户", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm(`确定将用户${selection[0].userName}的密码重置为GkMes2026吗?`, "提示", {
            type: "warning",
          })
            .then(() => {
              this.$http.get("basic", `system/user/initPassword/${selection[0].systemUserID}`).then((resp) => {
                if (resp.success) {
                  this.loadData(1);
                  this.$message.success("密码重置成功");
                }
              });
            })
            .catch(() => {});
        }
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
